"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _reactRedux = require("react-redux");
var _api = require("@react-google-maps/api");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _selectors = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _moment = _interopRequireDefault(require("moment"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _handlers = require("../../../../helpers/handlers");
var _price = require("../../../../helpers/price");
var _fn = require("../../../../helpers/fn");
var _pluralTranslations = require("../../../../localization/pluralTranslations");
var _Rating = _interopRequireDefault(require("../../../Results/components/Hotel/components/Rating"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledButton = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: ", ";\n"])), function (props) {
  return props.theme.primaryColor;
});
var convertTransport2LocaleKey = function convertTransport2LocaleKey(transport) {
  return R.call(R.cond([[R.equals('air'), R.always('PRICE_WITH_INCLUDED_AIR_TRANSPORT')], [R.equals('bus'), R.always('PRICE_WITH_INCLUDED_BUS_TRANSPORT')], [R.T, R.always(null)]]), transport);
};
var preventBubbleEventToMap = function preventBubbleEventToMap(ref) {
  return ref && global.window.google.maps.OverlayView.preventMapHitsFrom(ref);
};
var PricePopup = function PricePopup(_ref) {
  var currency = _ref.currency,
    hotelID = _ref.hotelID,
    offerID = _ref.offerID,
    onClick = _ref.onClick,
    onClose = _ref.onClose;
  var _useTranslation = (0, _reactI18next.useTranslation)('MAP'),
    t = _useTranslation.t;
  var nightsTranslation = (0, _pluralTranslations.usePluralNightsTranslation)();
  var peopleSufixAccusativeTranslation = (0, _pluralTranslations.usePluralPeopleSufixAccusativeTranslation)();
  var hotelSelector = (0, _react.useMemo)(function () {
    return offerID ? R.partialRight((0, _selectors.getHotel)(), [hotelID]) : R.partialRight((0, _selectors.getHotelMarker)(), [{
      hotelID: hotelID
    }]);
  }, [hotelID, offerID]);
  var offerSelector = (0, _react.useMemo)(function () {
    return offerID ? R.partialRight((0, _selectors2.getOffer)(), [{
      offerID: offerID
    }]) : R.always(null);
  }, [offerID]);
  var hotel = (0, _reactRedux.useSelector)(hotelSelector);
  var offer = (0, _reactRedux.useSelector)(offerSelector);
  var people = offer && offer.adults + offer.children;
  var transportLabel = offer && convertTransport2LocaleKey(offer.transport);
  return /*#__PURE__*/_react.default.createElement(_api.OverlayView, {
    mapPaneName: _api.OverlayView.OVERLAY_MOUSE_TARGET,
    position: hotel.location
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.popupWrapper,
    ref: preventBubbleEventToMap
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.popup
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.close,
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/_react.default.createElement("a", {
    href: onClick ? '#' : undefined,
    onClick: onClick ? (0, _handlers.handleWith)(_handlers.prevent, function () {
      return onClick(hotelID, offerID);
    }) : undefined
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.image,
    style: {
      backgroundImage: "url(\"".concat((0, _dictionary.getImageUrl)(hotel.photos[0], 'small', hotel.watermark), "\")")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.body
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.header
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.stars
  }, (0, _fn.combineHotelStars)(hotel.stars, hotel.secondaryStars)), hotel.sourceRatings && !R.isEmpty(hotel.sourceRatings) && /*#__PURE__*/_react.default.createElement(_Rating.default, {
    averageRating: hotel.averageRating,
    className: _styles.default.ratingWrapper,
    enabledHover: false,
    sourceRatings: hotel.sourceRatings
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.name
  }, hotel.name), offer && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.col
  }, offer.nights, ' ', nightsTranslation(offer.nights), ', ', (0, _moment.default)(offer.date).format('D MMMM')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.col
  }, R.toUpper(offer.food))), offer ? /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.price
  }, (0, _price.preparePriceForRender)(offer.price[currency.code], currency.symbol), /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.priceDesc
  }, t('PRICE_POPUP_INFORAMTION_ABOUT_TOUR', {
    peopleCount: people,
    peopleSufix: peopleSufixAccusativeTranslation(people),
    transportLabel: t(transportLabel)
  }))) : /*#__PURE__*/_react.default.createElement(StyledButton, {
    className: _styles.default.findButton
  }, t('PRICE_POPUP_SEARCH_TOURS_BUTTON')))))));
};
PricePopup.propTypes = {
  hotelID: _propTypes.default.string.isRequired,
  currency: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired
  }),
  offerID: _propTypes.default.string,
  onClose: _propTypes.default.func.isRequired,
  onClick: _propTypes.default.func
};
var _default = exports.default = (0, _react.memo)(PricePopup);